
    const data = {"name":"src/core/icons/watermark","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M21 3H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16h-9v-6h9v6Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            